module.exports = __webpack_public_path__ + "img/hohlsaum_grau_candy.a6a4b026.jpg";